/// <summary>
/// The BACKSPACE keycode
/// </summary>
export var BACKSPACE = 8;
/// <summary>
/// The TAB keycode
/// </summary>
export var TAB = 9;
/// <summary>
/// The ENTER keycode
/// </summary>
export var ENTER = 13;
/// <summary>
/// The SHIFT keycode
/// </summary>
export var SHIFT = 16;
/// <summary>
/// The CTRL keycode
/// </summary>
export var CTRL = 17;
/// <summary>
/// The ALT keycode
/// </summary>
export var ALT = 18;
/// <summary>
/// The ESC keycode
/// </summary>
export var ESC = 27;
/// <summary>
/// The SPACE keycode
/// </summary>
export var SPACE = 32;
/// <summary>
/// The PAGEUP keycode
/// </summary>
export var PAGEUP = 33;
/// <summary>
/// The PAGEDOWN keycode
/// </summary>
export var PAGEDOWN = 34;
/// <summary>
/// The END keycode
/// </summary>
export var END = 35;
/// <summary>
/// The HOME keycode
/// </summary>
export var HOME = 36;
/// <summary>
/// The ABSOLUTELEFTARROW keycode
/// </summary>
/// <remarks>It is always be the left arrow keycode regardless of whether it is in the RTL mode or not.</remarks>
export var ABSOLUTELEFTARROW = 37;
/// <summary>
/// The UPARROW keycode
/// </summary>
export var UPARROW = 38;
/// <summary>
/// The ABSOLUTERIGHTARROW keycode
/// </summary>
/// <remarks>It is always be the right arrow keycode regardless of whether it is in the RTL mode or not.</remarks>
export var ABSOLUTERIGHTARROW = 39;
/// <summary>
/// The DOWNARROW keycode
/// </summary>
export var DOWNARROW = 40;
/// <summary>
/// The INSERT keycode
/// </summary>
export var INSERT = 45;
/// <summary>
/// The DELETE keycode
/// </summary>
export var DELETE = 46;
/// <summary>
/// The D0 keycode
/// </summary>
export var D0 = 48;
/// <summary>
/// The '@' keycode
/// </summary>
export var AT = 50;
/// <summary>
/// The '#' keycode
/// </summary>
export var HASH = 51;
/// <summary>
/// The D9 keycode
/// </summary>
export var D9 = 57;
/// <summary>
/// The SEMICOLONFF keycode
/// </summary>
export var SEMICOLONFF = 59;
/// <summary>
/// The KeyA keycode
/// </summary>
export var KeyA = 65;
/// <summary>
/// The KeyC keycode
/// </summary>
export var KeyC = 67;
/// <summary>
/// The KeyK keycode
/// </summary>
export var KeyK = 75;
/// <summary>
/// The KeyN keycode
/// </summary>
export var KeyN = 78;
/// <summary>
/// The KeyV keycode
/// </summary>
export var KeyV = 86;
/// <summary>
/// The KeyX keycode
/// </summary>
export var KeyX = 88;
/// <summary>
/// The KeyZ keycode
/// </summary>
export var KeyZ = 90;
/// <summary>
/// The NUMPAD0 keycode
/// </summary>
export var NUMPAD0 = 96;
/// <summary>
/// The NUMPAD9 keycode
/// </summary>
export var NUMPAD9 = 105;
/// <summary>
/// The F2 keycode
/// </summary>
export var F2 = 113;
/// <summary>
/// The F6 keycode
/// </summary>
export var F6 = 117;
/// The F9 keycode
/// </summary>
export var F9 = 120;
/// <summary>
/// The F10 keycode
/// </summary>
export var F10 = 121;
/// <summary>
/// The SEMICOLON keycode
/// </summary>
export var SEMICOLON = 186;
/// <summary>
/// The COMMA keycode
/// </summary>
export var COMMA = 188;
/// <summary>
/// The DOT keycode
/// </summary>
export var DOT = 190;
/// <summary>
/// The TILDE keycode
/// </summary>
export var TILDE = 192;
/// <summary>
/// The OPENBRACKET keycode
/// </summary>
export var OPENBRACKET = 219;
/// <summary>
/// The CLOSEBRACKET keycode
/// </summary>
export var CLOSEBRACKET = 221;
/// <summary>
/// The FORWARDSLASH keycode
/// </summary>
export var FORWARDSLASH = 191;
/// <summary>
/// The BACKSLASH keycode
/// </summary>
export var BACKSLASH = 220;
/// <summary>
/// The APOSTROPHE keycode
/// </summary>
export var APOSTROPHE = 222;
//# sourceMappingURL=keycodes.js.map